import { useQuery } from '@tanstack/react-query';
import api from '../lib/api';

// Model interfaces
export interface Model {
  id: string; // e.g., "anthropic.claude-3-haiku-20240307-v1:0"
  name: string; // e.g., "Claude 3 Haiku"
  provider: string; // e.g., "Anthropic"
  inputModalities: string[];
  outputModalities: string[];
  inferenceTypes: string[];
  capabilities: string[];
  description?: string;
  isDefault?: boolean;
  isPremium?: boolean;
}

export interface ModelsResponse {
  data: Model[];
}

// Function to fetch available models
export const fetchAvailableModels = async (): Promise<ModelsResponse> => {
  const response = await api.get('/api/core/pleri/models');
  return response.data;
};

// React Query hook for models
export const useAvailableModels = () => {
  return useQuery<ModelsResponse, Error>({
    queryKey: ['pleri-models'],
    queryFn: fetchAvailableModels,
    staleTime: 1000 * 60 * 5, // 5 minutes
    select: (data) => ({
      ...data,
      data: data.data.filter((model) => model.id),
    }),
  });
};

// Fetch artifact download URL
export const fetchArtifactDownloadUrl = async (
  path: string,
): Promise<{ url: string }> => {
  const response = await api.get(
    `/api/core/pleri/artifact/download?path=${encodeURIComponent(path)}`,
  );
  return response.data;
};
